import {useState, useEffect} from 'react';

import {Modal} from 'shells/modal/modal';

import type {CalendarSync} from 'nutshell-graphql-types';

import {EmailCalendarSyncCompletionPage} from './email-calendar-sync-completion-page';
import {EmailCalendarSyncContactsPage} from './email-calendar-sync-contacts-page';
import type {EmailCalendarSyncSettings} from './email-calendar-sync-settings-page';
import {EmailCalendarSyncSettingsPage} from './email-calendar-sync-settings-page';

type Page = 'sync-settings' | 'contacts' | 'completion';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSaveSyncSettings: (settings: EmailCalendarSyncSettings) => Promise<void>;
    calendarSync: CalendarSync | null;
};

export function EmailCalendarSyncModal(props: Props) {
    const [currentPage, setCurrentPage] = useState<Page>('sync-settings');
    const [pendingSettings, setPendingSettings] = useState<EmailCalendarSyncSettings | null>(null);

    useEffect(() => {
        if (!props.isOpen) {
            setCurrentPage('sync-settings');
            setPendingSettings(null);
        }
    }, [props.isOpen]);

    let content = null;
    if (currentPage === 'sync-settings') {
        content = (
            <EmailCalendarSyncSettingsPage
                calendarSync={props.calendarSync}
                onSave={props.onSaveSyncSettings}
                onSaveSuccess={() => setCurrentPage('completion')}
                onNext={(settings: EmailCalendarSyncSettings) => {
                    setPendingSettings(settings);
                    setCurrentPage('contacts');
                }}
            />
        );
    } else if (currentPage === 'contacts' && pendingSettings) {
        content = (
            <EmailCalendarSyncContactsPage
                settings={pendingSettings}
                onSave={props.onSaveSyncSettings}
                onSaveSuccess={() => setCurrentPage('completion')}
            />
        );
    } else if (currentPage === 'completion') {
        content = <EmailCalendarSyncCompletionPage onClose={props.onClose} />;
    }

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            fitHeight={true}
            maxWidth={700}
            noPadding={true}
            canClickOutsideToClose={false}
            canEscapeToClose={false}
        >
            {content}
        </Modal>
    );
}
